import styled from 'styled-components'

export const Container = styled.div`
  min-height: calc(100vh - 56px);
`

export const Banner = styled.div`
  display: flex;
  background-color: var(--primary100);
  border-radius: 8px;
  padding: 0 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 340px;
  height: 124px;

  img {
    width: 95px;
    height: 100%;
  }
`

export const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 16px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`

export const HelpIcon = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .greenText {
    color: var(--success500);
  }
`

export const Counter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Payment = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`

export const CircleNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: var(--neutral-theme);
  background-color: var(--gray500);
`
export const Link = styled.span`
  color: var(--primary500);
  font-weight: 700;
`
